import { Button } from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';

export const Loader = () => (
  // <div className="loader">
  //   <div className="spinner"></div>
  // </div>
  <div class="loading-spinner">
    <div class="loading-spinner-inner">
      <div class="loading-spinner-circle"></div>
      <div class="loading-spinner-circle"></div>
      <div class="loading-spinner-circle"></div>
      <div class="loading-spinner-circle"></div>
      <div class="loading-spinner-circle"></div>
    </div>
  </div>
);

/// For Button Submit And Reset Button -------------->
export const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(lightBlue[600]),
  backgroundColor: lightBlue[500],
  fontFamily: "Poppins, sans-serif",
  width: "45%",
  marginLeft: "27%",

  "&:hover": {
    backgroundColor: lightBlue[600],
  },
}));

// CountDown ------>>>>>>>>
export const CountDown = ({ countdown, show, setShow }) => {
  const [timeRemaining, setTimeRemaining] = useState(countdown);

  useEffect(() => {
    if (timeRemaining <= 0) {
      setShow(false);
      return;
    }

    const intervalId = setInterval(() => {
      setTimeRemaining((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeRemaining]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${secs < 10 ? `0${secs}` : secs} sec.`;
  };

  return (
    <div className="error">
      <span>Too many failed attempts. Please try again after </span>
      <span className="error">{formatTime(timeRemaining)}</span>
    </div>
  );
};


export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, [location]);

  return null;
};